export enum EFieldAxis {
  X = 'x',
  Y = 'y',
  Both = 'both',
}
